import { useCallback, useMemo } from 'react';
import { Bleed, Card, SkeletonDisplayText } from '@shopify/polaris';
import MediaGrid, { getItemHeight, MediaGridSize } from '../media-asset/MediaGrid';

import './style.css';
export type EmptyGridProps = {
  size?: MediaGridSize;
  staticHeight?: number | string;
};

export default function EmptyGrid({ size = 'large', staticHeight }: EmptyGridProps) {
  const itemsCount = useMemo(() => {
    switch (size) {
      case 'small':
        return 16;
      case 'medium':
        return 12;
      case 'large':
        return 8;
    }
  }, [size]);
  const items = useMemo(() => {
    return [...Array(itemsCount)].map((_, index) => ({ id: `${index}` }));
  }, [itemsCount]);
  const itemHeight = getItemHeight(size);

  const renderItem = useCallback(
    ({ id }) => (
      <div className="empty-grid-item relative inline aspect-[9/16] gap-4" style={{ height: itemHeight }} key={id}>
        <Card>
          <Bleed marginInline="400" marginBlock="400">
            <div style={{ height: itemHeight }}>
              <SkeletonDisplayText size={size} maxWidth="100%" />
            </div>
          </Bleed>
        </Card>
      </div>
    ),
    [size, itemHeight]
  );
  return <MediaGrid size={size} items={items} renderItem={renderItem} staticHeight={staticHeight} />;
}
